export const mediaDevicesPool = [
    {
      mediaText: "Everyone is buying the new phone—you should too!",
      device: "Bandwagon",
      distractors: ["Testimonial", "Emotional Appeal", "Repetition"]
    },
    {
      mediaText: "This toothpaste is recommended by dentists.",
      device: "Testimonial",
      distractors: ["Bandwagon", "Repetition", "Emotional Appeal"]
    },
    {
      mediaText: "Just do it. Just do it. Just do it.",
      device: "Repetition",
      distractors: ["Bandwagon", "Testimonial", "Emotional Appeal"]
    }
  ];
  